import React, { useContext } from "react"
import { makeStyles } from "@material-ui/styles"
import { ProductCard, CartContext } from ".."
import moltinThreshold from '../../constants/moltinThreshold'

const useStyles = makeStyles(theme => {
  return {
    root: {
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(2),
      },
    },
  }
})

export default props => {
  const classes = useStyles(props)
  const { items } = useContext(CartContext)
  const i18nmessages = require(`../../puraearth/src/messages/index/${props.langKey}`)

  const mapItems = cartItems =>
    cartItems.map(item => {
      const outOfStockText = i18nmessages.outOfStock

      if (item.sku !== "shipping" && item.type !== "promotion_item") {
        let isOutOfStock = false
        if (item.inventory) {
          isOutOfStock = item.inventory.data.available <= parseInt(moltinThreshold.thresholdValue)
        }

        return (
          <ProductCard
            key={item.id}
            quantity={item.quantity}
            id={item.id}
            productId={item.product_id}
            name={item.name}
            price={item.meta.display_price.without_tax.unit.formatted}
            imageHref={item.image.href}
            outOfStock={outOfStockText}
            isOutOfStock={isOutOfStock}
          />
        )
      }
      return null
    })

  return <div className={classes.root}>{mapItems(items)}</div>
}
